<div class="modal-header">
  <h5 class="modal-title" id="myModalLabel">{{ title | translate }}</h5>
  <button
    type="button"
    class="btn-close"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="onClose('cancel')"
  ></button>
</div>
<div class="modal-body commentLikeBody" style="max-height: 350px; overflow-x: auto">
  <div class="container" *ngIf="data?.length">
    <div class="row py-2" *ngFor="let commentOrLike of data; let commentIndex = index">
      <div class="col-1 d-flex justify-content-end">
        <img
          style="height: 30px; width: 30px"
          [src]="commentOrLike.profilePic ? environment.imageUrl + commentOrLike.profilePic : 'assets/images/user.png'"
          class="img-fluid rounded-circle"
          alt="avatar"
        />
      </div>
      <div class="col-11 p-1">
        <div
          [ngClass]="commentIndex === commentIndexTs ? 'bg-soft-warning text-dark rounded-2 p-1' : ''"
          class="row w-100"
        >
          <div class="col-6 d-flex flex-column">
            <div>{{ commentOrLike.userName }}</div>
            <div class="fw-bolder text-break" *ngIf="!commentOrLike.isEditing">{{ commentOrLike.comment }}</div>
          </div>
          <div class="col-4">
            {{ commentOrLike.createdAt | timeFromNow }}
          </div>
          <div *ngIf="commentOrLike.likes" class="col-2 d-flex justify-content-end">
            <div class="d-flex align-items-center flex-column">
              <i-feather class="icon-md text-danger" name="heart"></i-feather>
              <span>{{ commentOrLike.likes?.length }}</span>
            </div>
            <div class="d-flex justify-content-center cursor-pointer">
              <div class="btn-group dropstart mb-2">
                <i-feather
                  class="icon-md"
                  name="more-vertical"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                ></i-feather>
                <ul class="dropdown-menu" [ngClass]="isRTL ? 'dropdown-rtl' : 'dropdown-ltr'">
                  <li
                    class="dropdown-item"
                    (click)="
                      setCommentObject({
                        postId,
                        repliedTo: commentOrLike.userId,
                        userId: currentUser._id,
                        repliedToName: commentOrLike.userName,
                        commentId: commentOrLike._id,
                        commentIndex,
                        hasReplies: commentOrLike?.replies?.length,
                        isAdmin: true,
                      })
                    "
                  >
                    {{ 'reply.value' | translate }}
                  </li>
                  <li class="dropdown-item" (click)="commentOrLike.isEditing = true">{{ 'edit.value' | translate }}</li>
                  <li
                    class="dropdown-item"
                    (click)="deleteComment({ postId, commentId: commentOrLike._id, commentIndex })"
                  >
                    {{ 'delete.value' | translate }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <small>
          <!-- <span class="text-break" *ngIf="!commentOrLike.isEditing"> {{ commentOrLike.comment }}</span> -->
          <div *ngIf="commentOrLike.isEditing" class="input-group mb-3">
            <input
              type="text"
              [(ngModel)]="commentOrLike.comment"
              class="form-control"
              placeholder="Comment"
              aria-label="Comment"
              aria-describedby="basic-addon2"
            />
            <button
              class="input-group-text btn btn-soft-primary"
              id="basic-addon2"
              (click)="saveComment(commentOrLike)"
            >
              {{ 'save.value' | translate }}
            </button>
            <button type="button" class="btn btn-soft-danger ms-1" (click)="commentOrLike.isEditing = false">
              {{ 'cancel.value' | translate }}
            </button>
          </div>
        </small>

        <div class="container-fluid p-1 mt-2 repliesDiv" *ngIf="commentOrLike.replies?.length">
          <div class="row" *ngFor="let replies of commentOrLike.replies; let repliesIndex = index">
            <div class="col-1 d-flex justify-content-end">
              <img
                style="height: 26px; width: 26px"
                [src]="replies.profilePic ? environment.imageUrl + replies.profilePic : 'assets/images/user.png'"
                class="img-fluid rounded-circle"
                alt="avatar"
              />
            </div>
            <div class="col-11">
              <div
                [ngClass]="
                  commentIndex === commentIndexTs && repliesIndex === repliesIndexTs
                    ? 'bg-soft-warning text-dark rounded-1 p-1'
                    : ''
                "
                class="row align-items-center"
              >
                <div class="col-6 d-flex flex-column">
                  <div>{{ replies.userName }}</div>
                  <div *ngIf="!replies.isEditing">
                    <span class="text-primary">{{ replies.repliedToName }} </span>
                    <b class="text-break">{{ replies.comment }}</b>
                  </div>
                </div>
                <div class="col-4">
                  {{ replies.createdAt | timeFromNow }}
                </div>
                <div *ngIf="replies.likes" class="col-2 d-flex justify-content-center">
                  <div class="d-flex align-items-center flex-column">
                    <i-feather class="icon-md text-danger" name="heart"></i-feather>
                    <span>{{ replies.likes?.length }}</span>
                  </div>
                  <div class="d-flex justify-content-center cursor-pointer">
                    <div class="btn-group dropstart mb-2">
                      <i-feather
                        class="icon-md"
                        name="more-vertical"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      ></i-feather>
                      <ul class="dropdown-menu" [ngClass]="isRTL ? 'dropdown-rtl' : 'dropdown-ltr'">
                        <li
                          class="dropdown-item"
                          (click)="
                            setCommentObject({
                              postId,
                              repliedTo: replies.userId,
                              userId: currentUser._id,
                              repliedToName: replies.userName,
                              commentId: commentOrLike._id,
                              subCommentId: replies._id,
                              repliesIndex,
                              commentIndex,
                              isAdmin: true,
                            })
                          "
                        >
                          {{ 'reply.value' | translate }}
                        </li>
                        <li class="dropdown-item" (click)="replies.isEditing = true">{{ 'edit.value' | translate }}</li>
                        <li
                          class="dropdown-item"
                          (click)="
                            deleteComment({
                              postId,
                              commentId: commentOrLike._id,
                              subCommentId: replies._id,
                              commentIndex,
                              repliesIndex,
                            })
                          "
                        >
                          {{ 'delete.value' | translate }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <small>
                <!-- <b>{{ replies.repliedToName }}</b>
                <span class="text-break" *ngIf="!replies.isEditing"> {{ replies.comment }}</span> -->
                <div *ngIf="replies.isEditing" class="input-group mb-3">
                  <input
                    type="text"
                    [(ngModel)]="replies.comment"
                    class="form-control"
                    placeholder="Comment"
                    aria-label="Comment"
                    aria-describedby="basic-addon2"
                  />
                  <button
                    class="input-group-text btn btn-soft-primary"
                    id="basic-addon2"
                    (click)="saveComment(replies, commentOrLike._id)"
                  >
                    {{ 'save.value' | translate }}
                  </button>
                  <button type="button" class="btn btn-soft-danger ms-1" (click)="replies.isEditing = false">
                    {{ 'cancel.value' | translate }}
                  </button>
                </div>

                <!-- <input
                  *ngIf="replies.isEditing"
                  class="form-control"
                  type="text"
                  [(ngModel)]="replies.comment"
                  (blur)="saveComment(commentOrLike._id, replies)"
                  (keydown.enter)="saveComment(commentOrLike._id, replies)"
                /> -->
              </small>
            </div>
            <!-- New design -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container" *ngIf="!data?.length">
    <h6>{{ 'no.value' | translate }} {{ title | translate }}...</h6>
  </div>
</div>
<div class="modal-footer d-flex flex-column" *ngIf="postId">
  <div *ngIf="commentObject?.repliedToName" class="row w-100">
    <div class="col-12">
      <p class="fw-bolder">{{ 'reply.value' | translate }} {{ commentObject.repliedToName }}</p>
    </div>
  </div>
  <div class="row w-100">
    <div class="col-9">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="comment"
          id="comment"
          placeholder="{{ 'comment.value' | translate }}"
        />
        <div class="input-group-prepend">
          <button [disabled]="!comment" class="input-group-text btn btn-soft-info" (click)="sendComment()">
            <!-- <i-feather class="icon-md" name="send"></i-feather> -->
            {{ 'send.value' | translate }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-3">
      <div class="resetButton">
        <button type="button" class="w-100 btn btn-soft-danger" (click)="resetValues()">
          {{ 'clear.value' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
